import { getAxiosInstance } from './dataService';
import formatISO from 'date-fns/formatISO';

// Gets static content stored in contentful.
export const fetchStaticContent = async ({ queryKey }) => {
	const [, apiEnv, product, type] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			`static-content?type=${type}&product=${product}`
		)
	).data;
};

// Gets FAQs stored in contentful.
export const fetchFAQ = async ({ queryKey }) => {
	const [, apiEnv, product] = queryKey;

	return (await getAxiosInstance(apiEnv).get(`FAQ?product=${product}`)).data;
};

// Headers will be empty unless we're using live API testing
const getHeaders = ssId => ({
	headers: ssId
		? {
				'X-SS-ID': ssId,
		  }
		: {},
});

// Gets business info data for contact us
export const fetchBusinessInfo = async ({ queryKey }) => {
	const [, apiEnv, ssId, isLoggedIn, product] = queryKey;

	const businessInfoUrl = isLoggedIn
		? '/BusinessInformation/Custom'
		: '/BusinessInformation/Default';

	try {
		const result = (
			await getAxiosInstance(apiEnv).get(businessInfoUrl, {
				params: {
					Product: product,
				},
				...getHeaders(ssId),
			})
		).data;
		return result;
	} catch (error) {
		return error;
	}
};

// Gets member contact info for contact us
export const fetchMemberContact = async ({ queryKey }) => {
	const [, apiEnv, ssId, isLoggedIn] = queryKey;

	if (!isLoggedIn) {
		return;
	}

	try {
		const result = (
			await getAxiosInstance(apiEnv).get('/member-contact-info', {
				...getHeaders(ssId),
			})
		).data;
		// eslint-disable-next-line consistent-return
		return result;
	} catch (error) {
		// eslint-disable-next-line consistent-return
		return error;
	}
};

// Gets member terms for termsAgreement
export const fetchMemberTerms = async ({ queryKey }) => {
	const [, apiEnv, ssId, product] = queryKey;

	const result = (
		await getAxiosInstance(apiEnv).get(`Terms?Product=${product}`, {
			...getHeaders(ssId),
		})
	).data;

	// check if result returned from backend contains `terms` prop
	// because in the scenaior where there is no resource associated with the product OR there is no terms in site content, backend will return an empty object
	// if it is empty object, we want to modify the result to return `{ noTerms: { } }`, so the UI will take users to next page
	const data = result && result.terms ? result : { noTerms: {} };

	return data;
};

// Puts member terms when members click accept
export const updateMemberTerms = async (apiEnv, ssId, userAgreementId) =>
	(
		await getAxiosInstance(apiEnv).put(
			`Terms`,
			{
				userAgreementId,
			},
			{
				...getHeaders(ssId),
			}
		)
	).data;

// Submit the contact form
export const submitContactUsForm = async (
	apiEnv,
	ssId,
	isLoggedIn,
	product,
	data
) => {
	const contactUrl = isLoggedIn
		? `/MemberContactUs/${product}`
		: `/ContactUs/${product}`;

	const formattedData = {
		...data,
		dateOfBirth:
			data?.dateOfBirth &&
			formatISO(data.dateOfBirth, {
				representation: 'date',
			}),
	};

	return getAxiosInstance(apiEnv).post(contactUrl, formattedData, {
		...getHeaders(ssId),
	});
};

// Get Editorial Policy stored in contentful.
export const fetchEditorialPolicy = async ({ queryKey }) => {
	const [, apiEnv, product] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(`EditorialPolicy?Product=${product}`)
	).data;
};

// Gets member agreements
export const fetchMemberAgreements = async ({ queryKey }) => {
	const [, apiEnv, ssId, product] = queryKey;

	const result = (
		await getAxiosInstance(apiEnv).get(
			`/memberAgreements?Product=${product}`,
			{
				...getHeaders(ssId),
			}
		)
	).data;

	// check if result returned from backend contains `memberAgreements` prop
	// because in the scenaior where there is no resource associated with the product OR there is no agreements in site content, backend will return an empty object
	// if it is empty object, we want to modify the result to return `{ noAgreements: { } }`, so the UI will take users to next page
	const data =
		result && result.memberAgreements ? result : { noAgreements: {} };

	return data;
};

// Puts member agreements when members click accept
export const updateMemberAgreements = async (apiEnv, ssId, data) =>
	(
		await getAxiosInstance(apiEnv).put(
			'/memberAgreements',
			data,
			{
				...getHeaders(ssId),
			}
		)
	).data;

